import {
  parseSessionCookie,
  SSO_SESSION_COOKIE_NAME,
} from 'commonUtils/src/sessionManager';
import { storage } from '@abyss/web/tools/storage';
import { loginNotRequired } from '@/components/TimeoutModal/utils';
import { SessionInitStatus } from '@/common/constants';

export const setLogout = (
  initStatus: keyof typeof SessionInitStatus,
  uniqueMemberId: string | undefined,
  currentSsoCookie: string
): {
  shouldLogout: boolean;
  shouldResetTimer: boolean;
  latestCookie: string;
} => {
  const ssoSessionCookie = storage?.cookie?.get(SSO_SESSION_COOKIE_NAME) || '';
  if (initStatus == SessionInitStatus.SUCCESS) {
    if (ssoSessionCookie.length > 0 && uniqueMemberId) {
      const parsedSession = parseSessionCookie(ssoSessionCookie);
      const parsedCurrentStoredCookie = parseSessionCookie(currentSsoCookie);

      if (uniqueMemberId !== parsedSession.memberId) {
        return {
          shouldLogout: true,
          shouldResetTimer: false,
          latestCookie: ssoSessionCookie,
        };
      } else if (
        uniqueMemberId === parsedSession.memberId &&
        parsedSession.lastAccessedSecs !==
          parsedCurrentStoredCookie.lastAccessedSecs
      ) {
        return {
          shouldLogout: false,
          shouldResetTimer: true,
          latestCookie: ssoSessionCookie,
        };
      }
    }
    if (!ssoSessionCookie && !loginNotRequired()) {
      return {
        shouldLogout: true,
        shouldResetTimer: false,
        latestCookie: ssoSessionCookie,
      };
    }
    return {
      shouldLogout: false,
      shouldResetTimer: false,
      latestCookie: ssoSessionCookie,
    };
  }
  return {
    shouldLogout: false,
    shouldResetTimer: false,
    latestCookie: ssoSessionCookie,
  };
};
